<template>
  <single-page>
    <template #breadcrumbs>
      <router-link
        v-if="venue.group"
        :to="{ name: 'admin-venue-groups' }">{{ $helpers.remapNaming('venues') }}</router-link>
      <span>/</span>
      <router-link
        v-if="venue.group"
        :to="{
          name: 'admin-venue-groups-info',
          params: {
            groupId: groupId,
          }
        }">{{ venue.group.name }}</router-link>
    </template>

    <template #title>
      <v-entity-title :entity="venue" :name="`${venue.group.name} - ${venue.name}`" />
    </template>
    <template #actions>
      <ez-button-dropdown buttonType="secondary">
        <template #icon>
          <font-awesome-icon icon="ellipsis-h"/>
        </template>
        <template #dropdown>
          <ez-button
            @click="onDeleteVenue"
            type="red-link">Delete {{ $helpers.remapNaming('venue') }}</ez-button>
        </template>
      </ez-button-dropdown>
    </template>
    <template #navigation>
      <ul>
        <li>
          <router-link
            :to="{ name: 'admin-venue-info' }">{{ $helpers.remapNaming('venue') }} Info</router-link>
        </li>
        <li>
          <router-link
            :to="{ name: 'admin-venue-distributors' }">
            Connected {{ $helpers.remapNaming('distributors')}}
          </router-link>
        </li>
        <li>
          <router-link
            :to="{ name: 'admin-venue-pending-updates' }">
            Pending Updates
          </router-link>
        </li>
      </ul>
    </template>
    <ez-confirmation-modal ref="deleteModal" type="red">
      <template #title>Delete this {{ $helpers.remapNaming('venue', 'lower') }}?</template>
      <template #content>
        <p>When deleted, this {{ $helpers.remapNaming('venue', 'lower') }}
          will no longer be live on OrderEZ.</p>

        <p>You won’t see this {{ $helpers.remapNaming('venue', 'lower') }}
          in admin panel as well.</p>
      </template>
      <template #footer>
        <ez-button @click="closeDeleteModal" type="link">Cancel</ez-button>
        <ez-button @click="confirmDeleteVenue" type="red">Yes, Delete</ez-button>
      </template>
    </ez-confirmation-modal>
  </single-page>
</template>

<script>
import { mapActions } from 'vuex';
import EzButton from '@/components/ui/Button';
import EzButtonDropdown from '@/components/ui/ButtonDropdown';
import { EzConfirmationModal } from '@/components/ui/Modal';
import VEntityTitle from '@/components/v3/patterns/VEntityTitle';
import SinglePage from '@/views/admin/SinglePage.vue';
import Venue from '@/models/Venue';

export default {
  components: {
    EzButton,
    EzButtonDropdown,
    EzConfirmationModal,
    VEntityTitle,
    SinglePage,
  },
  props: {
    venueId: {
      type: Number,
      required: true,
    },
    groupId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    venue() {
      return Venue.query()
        .with('group')
        .find(this.venueId) || { group: {} };
    },
  },
  methods: {
    onDeleteVenue() {
      this.$refs.deleteModal.open();
    },
    confirmDeleteVenue() {
      const { venueId } = this;

      this.removeVenue(venueId).then(() => {
        this.closeDeleteModal();

        this.$router.push({
          name: 'admin-venue-groups-venues',
          params: {
            groupId: this.groupId,
            flash: {
              type: 'success',
              title: `${this.$helpers.remapNaming('venue')} successfully deleted!`,
            },
          },
        });
      });
    },
    closeDeleteModal() {
      this.$refs.deleteModal.close();
    },
    ...mapActions('entities/venues', [
      'removeVenue',
    ]),
    ...mapActions('entities/groups', [
      'fetchGroup',
    ]),
  },
  mounted() {
    this.fetchGroup(this.groupId);
  },
};
</script>
